import { Field } from 'formik';
import React, { useEffect } from 'react';
import { Col, Collapse } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { BiBuildings } from 'react-icons/bi';
import Select from 'react-select';

export const BuilderData = ({ errors, touched, values, setValues }) => {
  const builderStatusOptions = [
    { value: '', label: '-- Selecciona el estado del emprendimiento --' },
    { value: 'En construcción', label: 'En construcción' },
    { value: 'En pozo', label: 'En pozo' },
    { value: 'Terminado', label: 'Terminado' }
  ];

  useEffect(() => {
    values.builder.project_status === 'Terminado' &&
      values.builder.deadline &&
      setValues(prev => ({
        ...prev,
        builder: {
          ...prev.builder,
          deadline: ''
        }
      }));
  }, [values]);

  return (
    <>
      <legend>
        <BiBuildings /> Datos generales
      </legend>

      <Col xs={12} md={5}>
        <label>Nombre de la constructora</label>
        <Field className="form-control" name="builder.name" />
        {errors.builder?.name && touched.builder?.name && (
          <label className="text-danger">{errors.builder?.name}</label>
        )}
      </Col>

      <Col xs={12} md={4}>
        <label>
          Estado del Emprendimiento <span className="text-danger">*</span>
        </label>
        <Select
          name="builder.project_status"
          options={builderStatusOptions}
          onChange={selectedOption => {
            setValues(prev => ({
              ...prev,
              builder: {
                ...prev.builder,
                project_status: selectedOption.value
              }
            }));
          }}
          value={
            builderStatusOptions.find(
              option => option.value === values.builder.project_status
            ) || builderStatusOptions[0]
          }
          isSearchable={false}
        />

        {errors.builder?.project_status && touched.builder?.project_status && (
          <label className="text-danger">
            {errors.builder?.project_status}
          </label>
        )}
      </Col>

      <Collapse
        in={
          values.builder.project_status &&
          (values.builder.project_status === 'En pozo' ||
            values.builder.project_status === 'En construcción')
        }
      >
        <Col xs={12} md={3}>
          <label>
            Fecha de entrega <span className="text-danger">*</span>
          </label>
          <Field type="date" className="form-control" name="builder.deadline" />
          {errors.builder?.deadline && touched.builder?.deadline && (
            <label className="text-danger">{errors.builder?.deadline}</label>
          )}
        </Col>
      </Collapse>

      <Col xs={12}>
        <label>Observaciones</label>
        <Field
          as="textarea"
          rows="4"
          className="form-control"
          name="builder.observations"
        />
      </Col>
    </>
  );
};

BuilderData.propTypes = {
  errors: PropTypes.object,
  touched: PropTypes.object,
  values: PropTypes.object,
  setValues: PropTypes.func
};
